import React from 'react';
import { useNavigate } from 'react-router-dom';

export const getCustToken = () => localStorage.getItem('pe_cust_token') || '';

// Celestial page shell — midnight → indigo/purple with soft gold accents, stars
export const SCShell = ({ children, className = '' }) => (
  <div className={`relative min-h-screen pt-28 pb-24 overflow-hidden ${className}`}
    style={{ background: 'radial-gradient(1200px 600px at 70% -10%, rgba(124,58,237,0.22), transparent), radial-gradient(900px 500px at 10% 20%, rgba(37,99,235,0.18), transparent), #060512' }}>
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {Array.from({ length: 30 }).map((_, i) => (
        <span key={i} className="absolute rounded-full bg-[#e9d8ff] twinkle"
          style={{ top: `${Math.random() * 100}%`, left: `${Math.random() * 100}%`, width: `${Math.random() * 2.5 + 1}px`, height: `${Math.random() * 2.5 + 1}px`, animationDelay: `${Math.random() * 3}s`, opacity: 0.6 }} />
      ))}
    </div>
    <div className="relative z-10 max-w-6xl mx-auto px-5">{children}</div>
  </div>
);

export const Chip = ({ active, children, onClick, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`px-4 py-2 rounded-full text-sm font-jost transition-all border ${active
      ? 'bg-gradient-to-r from-[#7c3aed] to-[#d946ef] text-white border-transparent shadow-[0_0_18px_rgba(124,58,237,0.5)]'
      : 'border-[#8b5cf6]/30 text-[#e9d8ff]/70 hover:border-[#d946ef]/60'}`}>
    {children}
  </button>
);

export const MultiChips = ({ options = [], value = [], onChange, max, testid }) => {
  const toggle = (o) => {
    const has = value.includes(o);
    if (has) onChange(value.filter((v) => v !== o));
    else if (!max || value.length < max) onChange([...value, o]);
  };
  return (
    <div className="flex flex-wrap gap-2.5" data-testid={testid}>
      {options.map((o) => <Chip key={o} active={value.includes(o)} onClick={() => toggle(o)}>{o}</Chip>)}
    </div>
  );
};

export const SCHeading = ({ eyebrow, title, sub }) => (
  <div className="mb-10">
    {eyebrow && <p className="font-jost text-xs tracking-[0.4em] text-[#d946ef] uppercase mb-3">{eyebrow}</p>}
    <h1 className="font-cinzel text-3xl md:text-5xl leading-tight" style={{ background: 'linear-gradient(90deg,#f5d786,#e9d8ff,#c4b5fd)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{title}</h1>
    {sub && <p className="font-cormorant text-xl text-[#e9d8ff]/70 mt-3 max-w-2xl">{sub}</p>}
  </div>
);

export const goldBtn = 'inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold text-[#0a0708] bg-gradient-to-r from-[#f5d786] via-[#fcefc7] to-[#f5d786] hover:opacity-90 transition-opacity';
export const ghostBtn = 'inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium text-[#e9d8ff] border border-[#8b5cf6]/40 hover:bg-[#8b5cf6]/10 transition-colors';

export const RequireAuth = ({ children }) => {
  const navigate = useNavigate();
  if (!getCustToken()) {
    return (
      <SCShell>
        <SCHeading eyebrow="Sacred Connections" title="Please sign in" sub="You need to be logged into your Prestige Elements account to use Sacred Connections." />
        <button className={goldBtn} data-testid="sc-signin-btn" onClick={() => navigate('/account')}>Go to My Account</button>
      </SCShell>
    );
  }
  return children;
};
